// const base_url = "https://ukvisa.herosolutions.com.pk/api/";
// const base_url = "http://localhost/work/ukvisa/";
// const base_url = "http://localhost/work/ukvisa-new/api/";
// const base_url = "http://localhost/herosols/ukvisa/ukvisa-server/";
// const base_url = "https://jobs.visajobsuk.com/ukvisa-api/";
// const base_url = "https://herosolutions.com.pk/abida/ukvisajobs/";
const base_url = "https://jobs.visajobsuk.com/ukvisa-api/";

const live_base_url =
  process.env.REACT_APP_ENV_MODE === "development" ? "/" : "/ukvisa";
const public_site_link = "https://visajobsuk.com/";
const resources_link = "https://visajobsuk.com/resources";
const community_link = "https://visajobsuk.com/community";
const events_link = "https://visajobsuk.com/events";
const faqs_link = "https://visajobsuk.com/faq";
const help_and_support_link = "https://visajobsuk.com/help-support";

// Cookie Config
const cookieDomain =
  process.env.REACT_APP_ENV_MODE === "development"
    ? "localhost"
    : ".visajobsuk.com";
const cookiePath = "/";

// const live_base_url = "";
// const public_site_link = "http://localhost:3000/";
// const resources_link = "http://localhost:3000/resources";
// const community_link = "http://localhost:3000/community";
// const events_link = "http://localhost:3000/events";
// const faqs_link = "http://localhost:3000/faq";
// const help_and_support_link = "http://localhost:3000/help-support";

module.exports = {
  API_BASE_URL: `${base_url}api/`,
  SITE_BASE_URL: `${live_base_url}`,
  PUBLIC_SITE_URL: `${public_site_link}`,
  API_UPLOADS_URL: `${base_url}uploads/`,
  API_ASSETS_IMAGES_URL: `${base_url}assets/images/`,
  API_CMS_BG_IMAGES_URL: `${base_url}uploads/images/`,
  resources_link: resources_link,
  community_link: community_link,
  events_link: events_link,
  faqs_link: faqs_link,
  help_and_support_link: help_and_support_link,

  COOKIE_CONFIG: {
    domain: cookieDomain,
    path: cookiePath,
  },
};
